import { Grid, Typography } from "@mui/material";

import { getPropertyOptions } from "@/utils/product/getPropertyOptions";
import CharacteristicCard from "./CharacteristicCard";
import Section from "@/components/Section";

interface IProps {
  title: string;
  properties: IProductProperties;
}

const MainCharacteristics: React.FC<IProps> = ({ title, properties }) => {
  const propertyOptions = getPropertyOptions(properties);

  return (
    <Section pt={0} pb={{ xs: 7.5, md: 10, lg: 15 }}>
      <Typography
        variant="h2"
        lineHeight={{ xs: 1.2, md: 1.4 }}
        mb={{ xs: 3, md: 7, lg: 8 }}
        maxWidth={1162}
        textAlign={{ xs: "start", md: "center" }}
        mx="auto"
      >
        Introducing {title}: empower your journey with 4G/LTE Precision
      </Typography>
      <Grid container spacing={{ xs: 4, md: 3 }}>
        {propertyOptions.map((property, index) => (
          <Grid item key={index} xs={6} md={4} lg={4}>
            <CharacteristicCard key={index} {...property} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default MainCharacteristics;
